<!-- <ng-container *ngIf="output && showResponse">
    <p>text-bison</p>
    <markdown lineNumbers [start]="5" [data]="output"></markdown>
</ng-container>

<br>
<p>------------------------------------------------------------------------</p>
<br> -->

<ng-container *ngIf="markdown && showResponse">
    <div class="d-flex justify-content-end mb-1">
        <div class="toolbar py-1 px-3 float-right">
            <!-- <img src="./assets/img/play_icon.svg" title="Play" class="cursor-pointer" /> -->
            <img src="./assets/img/copy_icon.svg" (click)="copyHtml()" [matTooltip]="isCopied ? 'Copied Successfully!' : 'Copy to clipboard'"
                class="ml-3 cursor-pointer" />
            <div class="menu-btn ml-4 d-inline-block" [matMenuTriggerFor]="menu">
                <img src="./assets/img/open_slides_blue_icon.svg" title="Download as" />
                <span type='button' class="text-primary mx-2">Export</span>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="exportAsPdf()"><img src="./assets/img/pdf_icon.svg" title="Download as PDF" class="mr-3" />Download as PDF</button>
                    <button mat-menu-item [disabled]="true" matTooltip="Coming soon"><img src="./assets/img/open_disabled_icon.svg" title="Open in Slides" class="mr-3" />Open in Google Slides</button>
                </mat-menu>
                <img src="./assets/img/down_arrow.svg" title="Download as" />
            </div>
        </div>
    </div>

    <markdown lineNumbers [start]="5" [data]="markdown" id="downloadableContent"></markdown>
</ng-container>
